import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseStepsWorker } from '../workers/warehouse.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseDataSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseStepsWorker | Remote<WarehouseStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/warehouse.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseStepsWorker()];
  }
}

export class WarehouseDownloadSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_WAR_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download warehouse sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseDataSyncWorkerFactory(), taskBreaker);
  }
}
